module.exports = __webpack_public_path__ + "img/con_item3_bgc.77f0096e.png";